import MetaHeader from '@buddieshr/components/metaHeader';
import { useRouter } from 'next/router';
import Header from '@buddieshr/components/header';
import Footer from '@buddieshr/components/footer';
import DemoPage from '@buddieshr/components/demo/demoPage';

export default function Demo({ refSource }) {
  const router = useRouter();

  return (
    <>
      <MetaHeader
        title="Book a 15-min demo | BuddiesHR"
        description="See BuddiesHR in action. Book a 15-minute demo and we'll show you how to run onboarding, recognition, engagement surveys and more, right inside Slack or Teams."
        currentURL={`https://buddieshr.com/${
          router.locale === 'en' ? '' : router.locale
        }/demo`}
        locale={router.locale}
        pageSlug="demo"
      />
      <Header />
      <main className="bh">
        <DemoPage />
      </main>
      <Footer refSource={refSource} />
    </>
  );
}
